import * as Yup from 'yup';
import { SECURE_LINK_VIA_DB } from '@/types/myVaultTypes';
import { CreateSecureLinkPayloadType } from '@/api/v1/organization/my-vault/createSecureLinkApi';

export type ShareFormType = Omit<CreateSecureLinkPayloadType, 'vault_account_id'>;

export const SHARE_INITIAL_VALUES = (rail: string): ShareFormType => ({
  rail,
  mode: 'verify',
  via: 'email',
  audience: 'recipient',
  sent_to: '',
  expiry_code: '7d',
  one_time: false,
  named_only: true,
});

export const shareValidationSchema = Yup.object({
  rail: Yup.string().required('Choose which instructions to share.'),
  sent_to: Yup.string().when('via', {
    is: SECURE_LINK_VIA_DB.EMAIL,
    then: (s) => s.trim().email('That email address does not look right.').required('Enter an email address.'),
    otherwise: (s) =>
      s.when('via', {
        is: SECURE_LINK_VIA_DB.SMS,
        then: (p) => p.trim().required('Enter a mobile number.'),
        otherwise: (p) => p.notRequired(),
      }),
  }),
});
